import 'jquery-mousewheel';

export default $.fn.canvasCtrl = function(models) {
    const $lbls = $('.canvas-ctrl__label', this);
    //Временно
    //const img = $('.screen__canvas img', this);

    let words = {
        ru: [
            'применении в шинах', 'применении в пластиках',
            'применении в РТИ', 'применении в печатных красках и тонерах', 'применении в пищевом контакте'
        ],
        en: [
            'the application in tires', 'the application in plastics',
            'the application in rubber products', 'the application in printing inks and toners', 'the application in kitchen accessories'
        ]
    };

    // let links = ['application1', 'application2', 'application3', 'application4', 'application5'];
    let links = [
        'production/application/#tires',
        'production/application/#plastics',
        'production/application/#rubber',
        'production/application/#inks',
        'production/application/#food',
    ];



    let model;

    class Model {
        constructor(i, c) {
            this.i = i;
            this.count = c;
            this._isModelChanging = false;
        }
        set index(i) {
            if (this._isModelChanging) {
                return;
            }
            this._isModelChanging = true;
            update(i, this.i);
            this.i = i;
            models.setModel(i).then(() => {
                this._isModelChanging = false;
            });
        }
        prev() {
            let newIndex = this.i - 1;
            newIndex = (newIndex < 0) ? this.count - 1 : newIndex;
            this.index = newIndex;
        }
        next() {
            let newIndex = this.i + 1;
            newIndex = (newIndex >= this.count) ? 0 : newIndex;
            this.index = newIndex;
        }
    }


    function update(newIndex, oldIndex) {
        $($lbls.get(oldIndex)).removeClass('is-active');
        $($lbls.get(newIndex)).addClass('is-active');

        //Временно
        //img.attr('src', `/media/images/bg-1_3_${i + 1}.jpg`)
        if (document.location.href.indexOf('en.') >= 0) {
            $('#application-link .change-page-link__text').html('More about ' + words['en'][newIndex]);
        } else {
            $('#application-link .change-page-link__text').html('Подробнее <br>о ' + words['ru'][newIndex]);
        }

        $('#application-link').attr('href', links[newIndex]);
    }


    function init() {
        let index;
        $lbls.map((i, el) => {
            !$(el).hasClass('is-active') || (() => {
                index = i;
            })();
        });
        if (index) {
            model = new Model(index, $lbls.length);
        } else {
            model = new Model(0, $lbls.length);
            update(0, null);
        }

        // переключение моделей
        $('[data-model-prev]', this).on('click', () => model.prev());
        $('[data-model-next]', this).on('click', () => model.next());
        $lbls.on('click', (e) => {
            model.index = $(e.target).index();
        });

        $('[data-canvas-ctrl-mouse-listener]', this).on('mousewheel', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (e.deltaY < 0) {
                model.next();
            } else {
                model.prev();
            }
        });
    }

    init();
}



// WEBPACK FOOTER //
// ./scripts/canvas-ctrl.js